import React, { Component } from 'react';

import moment from 'moment';

export default class ContestsViewInfo extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {

        }

        // Variables


        // Methods

    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {

    }

    render() {

        let cForm = this.props.identity;

        if (cForm === null || cForm === undefined) {
            return (
                <div className={this.props.className} style={this.props.style}>
                    <div className="gc-new-slide-container">
                        <div className={"gc-slide"} style={{ height: '48.5rem' }}>
                        </div>
                    </div>
                </div>
            );
        }

        let scope = cForm.locationId != null ? 'Location' : 'ClientAccount';
        let metricQty = cForm.reportKPIIdThree != null ? 3 : (cForm.reportKPIIdTwo != null ? 2 : 1);
        let metricMinQty = cForm.reportKPIIdMinThree != null ? 3 : (cForm.reportKPIIdMinTwo != null ? 2 : (cForm.reportKPIIdMinOne != null ? 1 : 0));

        let locationMapReverse = this.props.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
            let key = e.locationID;
            if (!r[key]) {
                r[key] = e.name;
            }
            return r;
        }, {});

        let kpiMapReverse = this.props.reportKPIs.reduce((r, e) => {

            if (e.kpiType === 'BLASTP') {
                let key = e.reportKpiId;
                if (!r[key]) {
                    r[key] = { name: e.name, type: e.type };
                }
            }

            return r;
        }, {});

        let monthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

        let activeKpiName1 = kpiMapReverse[cForm.reportKPIIdOne] != undefined ? kpiMapReverse[cForm.reportKPIIdOne].name : '';
        let activeKpiType1 = kpiMapReverse[cForm.reportKPIIdOne] != undefined ? kpiMapReverse[cForm.reportKPIIdOne].type : '';
        let activeKpiName2 = kpiMapReverse[cForm.reportKPIIdTwo] != undefined ? kpiMapReverse[cForm.reportKPIIdTwo].name : '';
        let activeKpiType2 = kpiMapReverse[cForm.reportKPIIdTwo] != undefined ? kpiMapReverse[cForm.reportKPIIdTwo].type : '';
        let activeKpiName3 = kpiMapReverse[cForm.reportKPIIdThree] != undefined ? kpiMapReverse[cForm.reportKPIIdThree].name : '';
        let activeKpiType3 = kpiMapReverse[cForm.reportKPIIdThree] != undefined ? kpiMapReverse[cForm.reportKPIIdThree].type : '';

        let activeKpiNameMin1 = kpiMapReverse[cForm.reportKPIIdMinOne] != undefined ? kpiMapReverse[cForm.reportKPIIdMinOne].name : '';
        let activeKpiTypeMin1 = kpiMapReverse[cForm.reportKPIIdMinOne] != undefined ? kpiMapReverse[cForm.reportKPIIdMinOne].type : '';
        let activeKpiNameMin2 = kpiMapReverse[cForm.reportKPIIdMinTwo] != undefined ? kpiMapReverse[cForm.reportKPIIdMinTwo].name : '';
        let activeKpiTypeMin2 = kpiMapReverse[cForm.reportKPIIdMinTwo] != undefined ? kpiMapReverse[cForm.reportKPIIdMinTwo].type : '';
        let activeKpiNameMin3 = kpiMapReverse[cForm.reportKPIIdMinThree] != undefined ? kpiMapReverse[cForm.reportKPIIdMinThree].name : '';
        let activeKpiTypeMin3 = kpiMapReverse[cForm.reportKPIIdMinThree] != undefined ? kpiMapReverse[cForm.reportKPIIdMinThree].type : '';

        let fromYear = moment(cForm.fromDate).format("YYYY");
        let fromMonth = moment(cForm.fromDate).format("MM");
        let fromDay = moment(cForm.fromDate).format("DD");
        let toYear = moment(cForm.toDate).format("YYYY");
        let toMonth = moment(cForm.toDate).format("MM");
        let toDay = moment(cForm.toDate).format("DD");

        return (
            <div className={this.props.className} style={this.props.style}>
                <div className="gc-new-slide-container full">
                    <div className={"gc-slide"} style={{ height: '48.5rem' }}>
                        <div className={"gc-review-header scope"}>
                            <div className={"gc-review-header-text"}>Scope</div>
                            <div className={"gc-review-underheader-alt"}>
                                {scope === 'ClientAccount' ? 'Company Wide' : 'Location Wide'}
                            </div>
                            <div className={"gc-review-underheader-alt"}>{"Location: " + (cForm.locationId != null ? locationMapReverse[cForm.locationId] : 'N/A')}</div>
                        </div>
                        <div className={"gc-review-header contest-type"}>
                            <div className={"gc-review-header-text"}>Contest Type</div>
                            <div className={"gc-review-underheader-alt"}>{cForm.contestType}</div>
                        </div>
                        <div className={"gc-review-header cidentity"}>
                            <div className={"gc-review-header-text"}>Identity</div>
                            <div className={"gc-review-underheader-alt"}>{'Name: ' + cForm.name}</div>
                            <div className={"gc-review-underheader-alt"}>{'Description: ' + cForm.description}</div>
                        </div>
                        <div className={"gc-review-header ctime"}>
                            <div className={"gc-review-header-text"}>Time</div>
                            <div className={"gc-review-underheader-alt"}>
                                {'The contest repeats every ' + (cForm.timeFrame != null ? cForm.timeFrame.toLowerCase() : '') + " beginning " +
                                    monthList[parseInt(fromMonth) - 1] + " " + fromDay + ", " + fromYear + " and ending " +
                                    monthList[parseInt(toMonth) - 1] + " " + toDay + ", " + toYear}
                            </div>
                        </div>
                        <div className={"gc-review-header cmetrics"}>
                            <div className={"gc-review-header-text"}>Objective Metrics</div>
                            <div className={"gc-review-underheader-alt"}>{"Quantity: " + metricQty}</div>
                            <div className={"gc-review-underheader-alt"}>
                                {
                                    activeKpiName1 + (cForm.contestType != 'Competition' ? (cForm.useUnderOne ? ' under ' : ' over ') : (cForm.useUnderOne ? ' lower ' : ' higher ')) + (cForm.contestType != 'Competition' ? ((activeKpiType1 === 'MNY' ? "$" : "") + cForm.valueOne + (activeKpiType1 === 'PCT' ? "%" : "")) : '')
                                }
                            </div>
                            <div className={"gc-review-underheader-alt"}>
                                {
                                    metricQty > 1 ?
                                        (activeKpiName2 + (cForm.contestType != 'Competition' ? (cForm.useUnderTwo ? ' under ' : ' over ') : (cForm.useUnderTwo ? ' lower ' : ' higher ')) + (cForm.contestType != 'Competition' ? ((activeKpiType2 === 'MNY' ? "$" : "") + cForm.valueTwo + (activeKpiType2 === 'PCT' ? "%" : "")) : ''))
                                        : 'No Second Objective'
                                }
                            </div>
                            <div className={"gc-review-underheader-alt"}>
                                {
                                    metricQty > 2 ?
                                        (activeKpiName3 + (cForm.contestType != 'Competition' ? (cForm.useUnderThree ? ' under ' : ' over ') : (cForm.useUnderThree ? ' lower ' : ' higher ')) + (cForm.contestType != 'Competition' ? ((activeKpiType3 === 'MNY' ? "$" : "") + cForm.valueThree + (activeKpiType3 === 'PCT' ? "%" : "")) : ''))
                                        : 'No Third Objective'
                                }
                            </div>
                        </div>
                        <div className={"gc-review-header cminmetrics"}>
                            <div className={"gc-review-header-text"}>Qualifier Metrics</div>
                            <div className={"gc-review-underheader-alt"}>{"Quantity: " + metricMinQty}</div>
                            <div className={"gc-review-underheader-alt"}>
                                {
                                    metricMinQty > 0 ?
                                        (activeKpiNameMin1 + (cForm.useUnderMinOne ? ' under ' : ' over ') + (activeKpiTypeMin1 === 'MNY' ? "$" : "") + cForm.valueMinOne + (activeKpiTypeMin1 === 'PCT' ? "%" : ""))
                                        : 'No First Qualifier'
                                }
                            </div>
                            <div className={"gc-review-underheader-alt"}>
                                {
                                    metricMinQty > 1 ?
                                        (activeKpiNameMin2 + (cForm.useUnderMinTwo ? ' under ' : ' over ') + (activeKpiTypeMin2 === 'MNY' ? "$" : "") + cForm.valueMinTwo + (activeKpiTypeMin2 === 'PCT' ? "%" : ""))
                                        : 'No Second Qualifier'
                                }
                            </div>
                            <div className={"gc-review-underheader-alt"}>
                                {
                                    metricMinQty > 2 ?
                                        (activeKpiNameMin3 + (cForm.useUnderMinThree ? ' under ' : ' over ') + (activeKpiTypeMin3 === 'MNY' ? "$" : "") + cForm.valueMinThree + (activeKpiTypeMin3 === 'PCT' ? "%" : ""))
                                        : 'No Third Qualifier'
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="gc-next-bar flat">

                </div>
            </div>
        );
    }
}